import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SIGN_IN_URL } from 'src/app/constants/storage-constants';
import { RootLayoutComponent } from '../root-layout/root-layout.component';

@Component({
  selector: 'e360-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: true,
  imports: [TranslateModule, RootLayoutComponent]
})
export class AlertComponent implements OnInit, OnDestroy {
  private readonly _unsubscribe = new Subject();

  isError: boolean = false;
  message: string = '';
  signInLink: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.data.pipe(takeUntil(this._unsubscribe)).subscribe(data => {
      this.message = data.message;
    });
  }

  ngOnInit() {
    if (this.router.url.includes('error')) {
      this.isError = true;
      this.signInLink = '';
    } else {
      this.isError = false;
      this.signInLink = localStorage.getItem(SIGN_IN_URL);
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(true);
    this._unsubscribe.complete();
  }
}
